import * as Yup from 'yup';
import Input from '@yoweb/ui/components/form/Input';
import { Text } from '@yoweb/ui/components/typography';
import { Grid } from '@yoweb/ui/components/Grid';
import { I_DO_NOT_KNOW_ID, MONEY_NANOS_MAX } from '@poplar/constants/intake';
import { usePreferredCurrency } from '@poplar/hooks/usePreferredCurrency';
import { getCurrencySymbol } from '@yoweb/utils/getCurrencySymbol';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getMoneyInitialValues = function getMoneyInitialValues(moneyAnswer, locale, currency) {
  var _moneyAnswer$answered, _moneyAnswer$answered2;

  var initial = '';
  var units = moneyAnswer === null || moneyAnswer === void 0 ? void 0 : (_moneyAnswer$answered = moneyAnswer.answeredMoney) === null || _moneyAnswer$answered === void 0 ? void 0 : _moneyAnswer$answered.units;
  var nanos = moneyAnswer === null || moneyAnswer === void 0 ? void 0 : (_moneyAnswer$answered2 = moneyAnswer.answeredMoney) === null || _moneyAnswer$answered2 === void 0 ? void 0 : _moneyAnswer$answered2.nanos;

  if (units !== undefined) {
    initial = "".concat(units);
  }

  if (initial !== '' && nanos !== undefined) {
    var _$split$;

    // nanos => 0.nanos
    var nanosFractional = nanos / MONEY_NANOS_MAX;
    var fractionalPartAsWhole = (_$split$ = "".concat(nanosFractional).split('.')[1]) !== null && _$split$ !== void 0 ? _$split$ : '0';
    initial = "".concat(initial, ".").concat(fractionalPartAsWhole);
  }

  return {
    amount: initial.length ? new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'code'
    }).formatToParts(parseFloat(initial)).filter(function (x) {
      return x.type !== 'currency' && x.type !== 'group';
    }).map(function (x) {
      return x.value;
    }).join('').trim() : '',
    currency: currency
  };
};
export var getMoneyValidationSchema = function getMoneyValidationSchema(isOptional, t) {
  var moneyValidation = Yup.number().min(0).nullable();
  return Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.object(),
    otherwise: Yup.object({
      amount: isOptional ? moneyValidation : moneyValidation.required(t('validation.required', {
        ns: 'common'
      })),
      currency: Yup.string()
    })
  });
};
export var MoneyElement = function MoneyElement(_ref) {
  var _moneyAnswer$inputFie;

  var instructionHint = _ref.instructionHint,
      moneyAnswer = _ref.moneyAnswer,
      isDisabled = _ref.isDisabled,
      id = _ref.id;
  var currency = usePreferredCurrency();
  var currencySymbol = getCurrencySymbol(currency);
  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small2",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), /*#__PURE__*/_jsx(Input, {
      id: id,
      name: "".concat(id, ".amount"),
      type: "number",
      label: (_moneyAnswer$inputFie = moneyAnswer === null || moneyAnswer === void 0 ? void 0 : moneyAnswer.inputFieldHint) !== null && _moneyAnswer$inputFie !== void 0 ? _moneyAnswer$inputFie : '',
      currencySymbol: currencySymbol,
      disabled: isDisabled
    }), /*#__PURE__*/_jsx(Input, {
      id: "".concat(id, ".currency"),
      name: "".concat(id, ".currency"),
      label: '',
      hidden: true
    })]
  });
};